var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnitPrice(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.988281,
    width: 30,
    height: 30,
    rx: 15,
    fill: "#F1B44C",
    fillOpacity: 0.1804
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.4884 14.1667H20.9884V8.33333C20.9884 7.8725 20.6159 7.5 20.155 7.5H8.48836C8.02753 7.5 7.65503 7.8725 7.65503 8.33333V20C7.65503 21.3783 8.7767 22.5 10.155 22.5H21.8217C23.2 22.5 24.3217 21.3783 24.3217 20V15C24.3217 14.5392 23.9492 14.1667 23.4884 14.1667ZM10.155 20.8333C9.69503 20.8333 9.3217 20.46 9.3217 20V9.16666H19.3217V20C19.3217 20.2925 19.3725 20.5733 19.4642 20.8333H10.155ZM22.655 20C22.655 20.46 22.2817 20.8333 21.8217 20.8333C21.3617 20.8333 20.9884 20.46 20.9884 20V15.8333H22.655V20Z",
    fill: "#F1B44C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9883 10.833H17.6549V12.4997H10.9883V10.833ZM10.9883 14.1664H17.6549V15.833H10.9883V14.1664ZM15.1549 17.4997H17.6549V19.1663H15.1549V17.4997Z",
    fill: "#F1B44C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnitPrice);
export default __webpack_public_path__ + "static/media/unit-price.ca44c076.svg";
export { ForwardRef as ReactComponent };